module.exports = __webpack_public_path__ + "static/img/Carbono Neutral.6774b089.png";